var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTriangle = function SvgTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v100z"
  })));
};
export { SvgTriangle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjEwMCIgd2lkdGg9IjQwIiBmaWxsPSJjdXJyZW50Q29sb3IiPgoJPHBvbHlnb24gcG9pbnRzPSIwLDAgNDAsMCA0MCwxMDAiICAvPgo8L3N2Zz4=";